<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="action-buttons-container">
  <div *ngFor="let button of buttonLabels" style="margin-left:5px;"
    class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="dynamicButtonClick(button)"
    (keydown.enter)="dynamicButtonClick(button)">
    <span class="reload_text text-white">{{button}}</span>
  </div>
</div>
<ng-template #confirmWithReasonPopup>
  <h2 mat-dialog-title>{{ title }}</h2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div style="margin: 15px 15px">
    <div class="">
      <div class="row" *ngIf="title == 'Execution Forward'">
        <div class="col-md-12">
          <div>
            <label for="reason"> Forward Stage</label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selctedForwardWorkflowStage"
            (closed)="workflowStageSearchText=''" (click)="focusSearch('focus-workflowForward-search')"
            (keydown.enter)="focusSearch('focus-workflowForward-search')">
            <input type="search" id="focus-workflowForward-search" class="dropdownsearchstyle"
              [(ngModel)]="workflowStageSearchText" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onWorkflowStageSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of dropdownToSelectWorkflowStage | assessmentSearch : workflowStageSearchText"
              [value]="item.valueExp" (onSelectionChange)="onWorkflowStageSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row" *ngIf="title == 'Execution Backward'">
        <div class="col-md-12">
          <div>
            <label for="reason"> Backward Stage</label>
          </div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selctedForwardWorkflowStage"
            (closed)="workflowStageSearchText=''" (click)="focusSearch('focus-workflowBackward-search')"
            (keydown.enter)="focusSearch('focus-workflowBackward-search')">
            <input type="search" id="focus-workflowBackward-search" class="dropdownsearchstyle"
              [(ngModel)]="workflowStageSearchText" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onWorkflowStageSelect($event,null)">Un-select</mat-option>
            <mat-option *ngFor="let item of dropdownToSelectWorkflowStage | assessmentSearch : workflowStageSearchText"
              [value]="item.valueExp" (onSelectionChange)="onWorkflowStageSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label for="reason"> Comments</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
          <div id="reason-val-icon" class="field-icon-container"></div>
          <span id="reason-required-msg">Please enter comments</span>
        </div>
      </div>
      <br>

    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
        {{ buttonLabel }}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #confirmWithDataPopup>
  <h2 mat-dialog-title>{{ buttonLabel }}</h2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div style="padding: 2%">
    <div class="row">
      <div class="col-md-6" style="border-right: 1px solid black">
        <div>
          <label style="margin-left: 20%; font-weight: 600" for="status">Action</label><span
            class="mandatory-symbol">*</span>
        </div>
        <mat-radio-group id="status" class="tp-radio-group" [(ngModel)]="selectedStatus"
          style="display: flex; flex-direction: column">
          <mat-radio-button class="tp-radio-button" *ngFor="let status of statusList" [value]="status.codelistCode"
            (change)="onStatusSelect(status.codelistCode)">
            {{ status.codelistName }}
          </mat-radio-button>
        </mat-radio-group>
        <span style="margin-left: 25%" id="status-required-msg">Please select status</span>
      </div>
      <div class="col-md-6" *ngIf="isEsignRequired" style="margin-top: 2%">
        <div class="row" *ngIf="isEsignRequired">
          <div>
            <label for="username ">User Name</label><span class="mandatory-symbol">*</span>
          </div>
          <div>
            <input id="username" style="height: 80% !important" class="input-filed-continers" type="text"
              [(ngModel)]="displayUserName" disabled />
          </div>
        </div>
        <div class="row" *ngIf="(isEsignRequired && !isAdenabled)">
          <div>
            <label for="pass ">Password</label><span class="mandatory-symbol">*</span>
          </div>
          <div>
            <input id="pass" style="height: 80% !important" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste />
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
          <span style="margin-left: 25%" id="pass-required-msg">Please enter password</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div><label for="comment">Comments</label></div>
      <div>
        <textarea rows="4" id="comment" class="textarea-filed-continers" type="text" [(ngModel)]="comments"></textarea>
      </div>
    </div>

    <div class="row" *ngIf="isShowRejectReason" style="width: 60%; margin-bottom: 1%">
      <div>
        <label for="rejectReason">Reject Reason</label><span class="mandatory-symbol">*</span>
      </div>
      <div>
        <mat-select id="rejectReason" matInput placeholder="Select" [(ngModel)]="selectedRejectReason"
          (closed)="rejectReasonSearchText=''" (click)="focusSearch('focus-reject-reason-search')"
          (keydown.enter)="focusSearch('focus-reject-reason-search')">
          <input type="search" id="focus-reject-reason-search" class="dropdownsearchstyle"
            [(ngModel)]="rejectReasonSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onRejectReasonSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of rejectReasonDropdown | assessmentSearch : rejectReasonSearchText"
            [value]="item.valueExp" (onSelectionChange)="onRejectReasonSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <span id="rejectReason-required-msg">Please select reject reason</span>
    </div>

    <div class="row" *ngIf="isReasonSignReqd" style="width: 80%; margin-bottom: 1%">
      <div>
        <label for="reasonForSignature">Reason for Signature</label><span class="mandatory-symbol">*</span>
      </div>
      <div>
        <mat-select id="rejectReason" matInput placeholder="Select" [(ngModel)]="selectedReason" id="reasonForSignature"
          (closed)="reasonSearchText=''" (click)="focusSearch('focus-reason-search')"
          (keydown.enter)="focusSearch('focus-reason-search')">
          <input type="search" id="focus-reason-search" class="dropdownsearchstyle" [(ngModel)]="reasonSearchText"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onReasonSelect($event,null)">Un-select</mat-option>
          <mat-option *ngFor="let item of reasonDropdown | assessmentSearch : reasonSearchText" [value]="item.valueExp"
            (onSelectionChange)="onReasonSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <span id="reasonForSignature-required-msg">Please select reason for signature</span>
    </div>

    <div class="row">
      <div><label for="comment">Document</label></div>
      <div>
        <input type="file" class="file-input" (change)="onConfirmFileSelected($event)" #fileUpload />
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="confirmWithDataFunc()">
      {{ buttonLabel }}
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelConfirmWithDataFunc()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
